import { render, staticRenderFns } from "./PxMunicipioEstado.vue?vue&type=template&id=a323f638"
import script from "./PxMunicipioEstado.vue?vue&type=script&lang=js"
export * from "./PxMunicipioEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports